import { Dispatch, SetStateAction } from "react"

import { IntegrationConnectDialogs } from "src/components/Integrations/IntegrationConnectDialogs/IntegrationConnectDialogs"
import { findBrokenConnection } from "src/data/integrations/logic/integrations"
import { TIntegration } from "src/data/integrations/types/integrationTypes"
import { useTranslate } from "src/i18n/useTranslate"
import ConfirmDialog from "src/ui/Dialog/ConfirmDialog"

export function ReconnectIntegration({
  showReconnectDialog,
  setShowReconnectDialog,
  integration,
  orgId,
  startAuthFlow,
  setStartAuthFlow,
}: {
  showReconnectDialog: boolean
  setShowReconnectDialog: (value: boolean) => void
  integration: TIntegration
  orgId: string
  startAuthFlow: boolean
  setStartAuthFlow: Dispatch<SetStateAction<boolean>>
}) {
  const { t, langKeys } = useTranslate()

  const brokenConnection = findBrokenConnection(integration)

  function handleConfirmReconnectClick() {
    setShowReconnectDialog(false)
    setStartAuthFlow(true)
  }

  if (!brokenConnection) {
    return null
  }

  return (
    <div>
      <ConfirmDialog
        title={t(langKeys.integrations_reconnect_integration_title)}
        open={!startAuthFlow && showReconnectDialog}
        onClose={() => setShowReconnectDialog(false)}
        onConfirm={handleConfirmReconnectClick}
        confirmLabel={t(langKeys.continue)}
      >
        {t(langKeys.integrations_reconnect_integration_description)}
      </ConfirmDialog>

      <IntegrationConnectDialogs
        startAuthFlow={startAuthFlow}
        setStartAuthFlow={setStartAuthFlow}
        integration={integration}
        orgId={orgId}
        reauthorizationAccountId={brokenConnection.account_id}
      />
    </div>
  )
}
